export default __webpack_public_path__ + "static/media/photo--sm--89.c29758bd.jpg";